import { QueryClient } from '@tanstack/react-query';

import { ErroApi } from './cliente';

/* QueryClient — configuração única do cache do front.
 *
 * Decisões:
 *  - staleTime de 30s: os dados desta ferramenta mudam por ação do próprio
 *    usuário, não por terceiros. Refazer a chamada a cada foco de janela só
 *    gastaria banco.
 *  - erro 4xx NÃO é repetido: 401/403/404/422 não melhoram na segunda vez.
 *  - refetchOnWindowFocus desligado: alternar para a planilha e voltar não
 *    pode piscar a tela inteira. */
export function criarQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (tentativa, erro) => {
          if (erro instanceof ErroApi && erro.culpaDoCliente) return false;
          return tentativa < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}

/** Chaves de cache num lugar só: invalidar errado é a fonte de tela velha. */
export const chaves = {
  eu: ['auth', 'eu'] as const,
  integrador: ['integrador', 'meu'] as const,
  projetos: ['projetos'] as const,
  projetoAtual: ['projetos', 'atual'] as const,
  projeto: (id: string) => ['projetos', id] as const,
  analise: (entrada: unknown) => ['calculo', 'analise', entrada] as const,
  orcamentos: ['orcamentos'] as const,
  diagnosticos: ['diagnosticos'] as const,
  cnpj: (cnpj: string) => ['integradores', 'cnpj', cnpj] as const,
  adminResumo: ['admin', 'resumo'] as const,
  adminEmpresas: (busca: string, pagina: number) => ['admin', 'empresas', busca, pagina] as const,
  adminEmpresa: (id: string) => ['admin', 'empresas', id] as const,
  adminAcessos: (dias: number) => ['admin', 'acessos', dias] as const,
  adminAdministradores: ['admin', 'administradores'] as const,
};
